/* VEJI contact: pure invitation policy, shared by the browser and Node tests. */
(function () {
  'use strict';
  function createInvitation(options) {
    var freeSince = null, shownAt = null, done = !!options.consumed;
    function consume() {
      done = true;
      try { return options.consume() === true; } catch (error) { return false; }
    }
    return {
      tick: function (now, eligible) {
        if (!eligible) { freeSince = null; shownAt = null; return false; }
        if (shownAt !== null) {
          if (now - shownAt >= 12000) shownAt = null;
          return shownAt !== null;
        }
        if (done || !options.enabled) return false;
        if (freeSince === null) freeSince = now;
        if (now - freeSince < 8000) return false;
        if (consume()) shownAt = now;
        return shownAt !== null;
      },
      dismiss: function () {
        if (!done) consume();
        shownAt = null;
        freeSince = null;
      }
    };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {createInvitation: createInvitation};

  function init() {
    var root = document.querySelector('[data-veji-support]');
    if (!root || root.dataset.vejiSupportReady) return;
    var button = root.querySelector('[data-veji-support-toggle]');
    var panel = root.querySelector('#veji-support-panel');
    var invite = root.querySelector('[data-veji-support-invite]');
    var fallback = root.querySelector('[data-veji-support-fallback]');
    if (!button || !panel || !invite || !fallback) return;
    var key = 'veji.whatsapp.invite.v1', storage = null, consumed = false;
    try { storage = window.sessionStorage; consumed = storage.getItem(key) === '1'; } catch (error) { storage = null; }
    function remember() {
      if (!storage) return false;
      try { storage.setItem(key, '1'); return storage.getItem(key) === '1'; } catch (error) { return false; }
    }
    var policy = createInvitation({enabled:root.dataset.vejiSupportHome === 'true' && !!storage, consumed:consumed, consume:remember});
    // Only known overlays are inspected; never walk every element of the page.
    var layers = '.veji-promo-modal,.shopify-pc__prefs__dialog,.shopify-pc__banner__dialog,[data-st-overlay],.veji-prod-hero-lightbox';
    function visible(element) {
      if (!element || element.hidden || !element.getClientRects().length) return false;
      var style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden';
    }
    function blocked() {
      if (document.body.classList.contains('veji-cookie-banner-visible') || document.body.classList.contains('veji-cart-open') || document.body.classList.contains('veji-menu-open')) return true;
      if (document.body.style.overflow === 'hidden' || document.documentElement.style.overflow === 'hidden') return true;
      return Array.prototype.some.call(document.querySelectorAll(layers), visible);
    }
    function coversInlineContact() {
      var contact = document.querySelector('.veji-product-contact, .veji-feel-contact');
      if (!visible(contact)) return false;
      var linkBox = contact.getBoundingClientRect(), buttonBox = button.getBoundingClientRect();
      return buttonBox.left < linkBox.right && buttonBox.right > linkBox.left && buttonBox.top < linkBox.bottom && buttonBox.bottom > linkBox.top;
    }
    function close(returnFocus) {
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');
      root.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', 'Ouvrir le panneau WhatsApp');
      if (returnFocus && !root.hidden) button.focus({preventScroll:true});
    }
    function open() {
      if (root.hidden || blocked()) return;
      policy.dismiss();
      invite.hidden = true;
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      root.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-label', 'Fermer le panneau WhatsApp');
      panel.querySelector('a').focus({preventScroll:true});
    }
    button.addEventListener('click', function () { if (panel.hidden) open(); else close(true); });
    root.querySelector('[data-veji-support-invite-open]').addEventListener('click', open);
    root.querySelector('[data-veji-support-invite-close]').addEventListener('click', function () { policy.dismiss(); invite.hidden = true; button.focus({preventScroll:true}); });
    document.addEventListener('click', function (event) { if (!root.contains(event.target)) close(false); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !panel.hidden) close(true); });
    panel.addEventListener('click', function (event) { if (event.target.closest('a')) close(false); });
    root.dataset.vejiSupportReady = 'true';
    fallback.hidden = true;
    button.hidden = false;
    function update() {
      var videoVisible = root.hasAttribute('data-veji-support-wait-for-founder') && Array.prototype.some.call(document.querySelectorAll('[data-st-bubble]'), visible);
      var unavailable = blocked() || videoVisible;
      // Measure in its normal position, then yield to the permanent contact link.
      // Do not use a hidden button's zero rect: that would alternate each tick.
      // Write only on change: a write before the reads forces a layout every call.
      if (!unavailable) {
        if (root.hidden) root.hidden = false;
        if (coversInlineContact()) unavailable = true;
      }
      if (unavailable && !panel.hidden) close(false);
      if (root.hidden !== unavailable) root.hidden = unavailable;
      var showInvite = policy.tick(performance.now(), !document.hidden && !unavailable && panel.hidden);
      if (invite.hidden === showInvite) invite.hidden = !showInvite;
    }
    // Scroll and resize fire many times per frame: one update per frame is enough.
    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; update(); });
    }
    var timer = null;
    function stop() { if (timer !== null) { clearInterval(timer); timer = null; } }
    function start() { stop(); update(); if (!document.hidden) timer = setInterval(update, 250); }
    document.addEventListener('veji:founder-video-dismissed', update);
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule);
    document.addEventListener('visibilitychange', function () {
      policy.tick(performance.now(), false);
      invite.hidden = true;
      if (document.hidden) stop(); else start();
    });
    window.addEventListener('pagehide', function () { stop(); policy.tick(performance.now(), false); invite.hidden = true; });
    window.addEventListener('pageshow', start);
    start();
  }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
    else init();
  }
})();
